import { HomeServerApi } from "../matrix/net/HomeServerApi";
import { SegmentType } from "./navigation";
import { Paths, PROFILE_STEP } from "./ProfileViewModel";
import { Options, ViewModel } from "./ViewModel";

export class DisplayNameViewModel extends ViewModel<SegmentType, Options> {
    private loading: boolean;
    private _sessionId: string;
    private _displayName: string;
    private _ensList: string[];
    constructor(options: Options) {
        super(options);
        this.loading = false;
        this._ensList = [];
        this._displayName = ''
        this._sessionId = options.sessionId;
        this.init()
    }

    async init(){
        this.loading = true;
        this.emitChange('loading')
        const step = localStorage.getItem(PROFILE_STEP);
        const {hsApi, sessionInfo} = await this.getSession()
        const profile = await  hsApi.profile(sessionInfo.userId).response();
        this._displayName = step === "1" ? profile.displayname : '';
        this.emitChange('displayName')
        const ensdomain = await hsApi
            .profile(sessionInfo.userId, "ensdomain")
            .response();
        this._ensList = ensdomain?.name ? [ensdomain?.name] : []
        this.emitChange('ensList')
        this.loading = false;
        this.emitChange('loading')
    }

    get displayName(){
        return this._displayName;
    }

    get ensList(){
        return this._ensList;
    }

    async getSession() {
        const sessionId = this._sessionId;
        const sessionInfo = await this.platform.sessionInfoStorage.get(
            sessionId
        );
        const request = this.platform.request;
        const hsApi = new HomeServerApi({ ...sessionInfo, request });
        return { hsApi, sessionInfo };
    }

    async saveDisplayName(){
        if(!this.displayName.trim()){
            return;
        }
        const sessionId = this.navigation.path.get('session')?.value
        if(sessionId){
            const {sessionInfo, hsApi} = await this.platform.getConfigBySessionId(sessionId);
            await hsApi.updateProfile(sessionInfo.userId, 'displayname', {displayname: this.displayName})
            this.onNext()
        }else {
            this.navigation.push('login', true);
        }
    }

    onNext(){
        this.navigation.push('profile', Paths.avatar)
    }

    async getHsApi(){
        const sessionId = this.navigation.path.get('session')?.value
        const request = this.platform.request;
        const sessionInfo = await this.platform.sessionInfoStorage.get(sessionId)
        const hsApi = new HomeServerApi({ ...sessionInfo, request });
        return hsApi
    }

    // async goToAvatar(){
    //     const sessionId = this.navigation.path.get('session')?.value
    //     if(sessionId){
    //         const sessionInfo = await this.platform.sessionInfoStorage.get(sessionId)
    //         const request = this.platform.request;
    //         const hsApi = new HomeServerApi({ ...sessionInfo, request });
    //         hsApi.updateProfile(sessionInfo.userId, 'avatar_url', {})
    //         localStorage.setItem(PROFILE_STEP, "1");
    //         const path = this.navigation.path.until('session')
    //         if(path){
    //             this.navigation.applyPath(path);
    //         }else{
    //             this.navigation.push('profile', 'avatar');
    //         }
    //     }else {
    //         this.navigation.push('login', true);
    //     }
    // }

    async setDisplayName(displayName: string){
        this._displayName=displayName;
        this.emitChange('displayName');
    }
}